import { Link } from 'react-router-dom';
import { useAuth } from '../../auth/AuthContext';
import TasteDashboard from '../History/TasteDashboard';
import '../History/History.css';
import './Taste.css';

// "Your taste": everything we've learned from swipes, ratings and film nights, on its own page.
const Taste = () => {
  const { user, loading } = useAuth();
  if (loading) return <main className="library"><p>Loading…</p></main>;
  if (!user) return <main className="library"><div className="library__empty"><h1>Your taste</h1><p>Sign in to see what we’ve learned about the films and actors you love.</p><Link to="/account">Sign in</Link></div></main>;
  return <main className="library taste-page">
    <Link to="/history" className="taste-page__back">← My films</Link>
    <header className="library__header"><p>WHAT WE’VE LEARNED</p><h1>Your taste</h1><span>Built from your ratings, swipes and film nights. The more you tell us, the sharper your picks.</span></header>
    <div className="taste-page__actions"><Link to="/swipe">🎬 Swipe films</Link><Link to="/swipe?type=actors">🎭 Swipe actors</Link></div>
    <TasteDashboard />
  </main>;
};

export default Taste;
